import { usePersistedQueryParams } from '@plato/app-shared/hooks/use-persisted-query-params';
import { Role } from '@plato/data/prisma';
import type { CustomTimeRange } from '@plato/shared-util/date-time-range';
import {
    dateOnlyParam,
    enumParam,
    jsonParam,
    objectParam,
    queryParamsConfig,
    requiredParam,
    stringParam,
    transientParam,
} from '@plato/ui-legacy/lib/query-params';
import type { TeamFilters } from '../../../server/queries/utils/visit-report-utils.ts';
import { VisibilityWindow } from '../../../server/utils/explorer-utils.ts';

const config = queryParamsConfig<TeamFilters>({
    window: enumParam(VisibilityWindow),
    customDateRange: objectParam<CustomTimeRange>({
        from: requiredParam(dateOnlyParam()),
        to: requiredParam(dateOnlyParam()),
    }),
    salesRegion: jsonParam(),
    userRole: enumParam(Role),
    searchUsers: transientParam(stringParam()),
});

const defaultFilters = {
    window: VisibilityWindow.YTD,
} satisfies Partial<TeamFilters>;

export function useTeamFilters() {
    const [appliedFilters, setAppliedFilters] = usePersistedQueryParams(config, defaultFilters, 'team');

    return {
        appliedFilters,
        setAppliedFilters,
    };
}
